import { supabase } from '@sixam/supabase/client';
import type { Tenant } from '@sixam/shared/tenant-core';
export {
  TENANT_ADMIN_ROLES,
  adminTenantsForUser,
  getMembershipRole,
  hasTenantAdminMembership,
  isUserTenantAdmin,
  isUserTenantOwner,
  memberTenantsForUser,
  resolveActiveTenant,
  type Membership,
  type Tenant,
  type TenantRole,
} from '@sixam/shared/tenant-core';

export const DEFAULT_TENANT_SLUG = process.env.EXPO_PUBLIC_DEFAULT_TENANT_SLUG ?? '6am.bkk';

/** Resolve a single tenant by its URL slug (readable publicly via RLS). */
export async function fetchTenantBySlug(slug: string): Promise<Tenant | null> {
  const { data, error } = await supabase.from('tenants').select('*').eq('slug', slug).maybeSingle();
  if (error) {
    throw error;
  }
  return data;
}

/** Resolve tenant metadata for registrations that came from clubs the user has not joined. */
export async function fetchTenantById(id: string): Promise<Tenant | null> {
  const { data, error } = await supabase.from('tenants').select('*').eq('id', id).maybeSingle();
  if (error) throw error;
  return data;
}

export async function fetchTenantsByIds(ids: readonly string[]): Promise<Tenant[]> {
  if (ids.length === 0) return [];
  const { data, error } = await supabase
    .from('tenants')
    .select('*')
    .in('id', [...ids]);
  if (error) throw error;
  return data ?? [];
}
